import _objectSpread from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["Share", "shareButtons", "csrftoken", "isAuthenticated", "isSharingEnabled", "uuid", "objtype"];
import React, { useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var ShareForButtonsAbstract = function ShareForButtonsAbstract(_ref) {
  var Share = _ref.Share,
    shareButtons = _ref.shareButtons,
    csrftoken = _ref.csrftoken,
    isAuthenticated = _ref.isAuthenticated,
    isSharingEnabled = _ref.isSharingEnabled,
    uuid = _ref.uuid,
    _ref$objtype = _ref.objtype,
    objtype = _ref$objtype === void 0 ? "dataset" : _ref$objtype,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState('show' in props ? props.show : false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var _useState3 = useState(props.uuid || ''),
    _useState4 = _slicedToArray(_useState3, 2),
    obj_id = _useState4[0],
    setObj_UUID = _useState4[1];
  useEffect(function () {
    shareButtons.forEach(function (shareButton) {
      shareButton.addEventListener('click', handleClick);
    });
    return function () {
      shareButtons.forEach(function (shareButton) {
        shareButton.removeEventListener('click', handleClick);
      });
    };
  }, [shareButtons]); // one-shot to avoid stacking click handlers

  var handleClick = function handleClick(event) {
    setObj_UUID(event.target.dataset.uuid);
    setShow(function (show) {
      return !show;
    }); //FIXME: true + wipe state?
  };
  if (!show) {
    return null;
  }
  return /*#__PURE__*/_jsx(Share, _objectSpread(_objectSpread({}, props), {}, {
    show: show,
    onHide: function onHide() {
      return setShow(false);
    },
    obj_id: obj_id,
    isAuthenticated: isAuthenticated,
    csrftoken: csrftoken,
    isSharingEnabled: isSharingEnabled,
    objtype: objtype
  }));
};
export { ShareForButtonsAbstract };